export default __webpack_public_path__ + "static/media/frame-breeding.9fe1d172.png";